(function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  // ─── Open / Close ───────────────────────────────────────────
  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-open');
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-open');
  }

  document.getElementById('cd-close')?.addEventListener('click', closeDrawer);
  document.getElementById('cd-overlay')?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // ─── Cart API helpers ────────────────────────────────────────
  async function notifyCartUpdated(source, variantId) {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json());
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cart, variantId: variantId });
      }
    } catch (e) {
      // swallow — subscribers can fetch /cart.js themselves on next interaction
    }
  }

  async function cartChange(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshDrawer();
    await notifyCartUpdated('cart-drawer', key);
  }

  async function cartAdd(variantId, quantity) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    await refreshDrawer();
    await notifyCartUpdated('cart-drawer', variantId);
    openDrawer();
  }

  async function refreshDrawer() {
    const res = await fetch('/?sections=cart-drawer');
    const data = await res.json();
    const tmp = document.createElement('div');
    tmp.innerHTML = data['cart-drawer'];
    const newDrawer = tmp.querySelector('#cart-drawer');
    if (newDrawer) {
      drawer.innerHTML = newDrawer.innerHTML;
      bindEvents();
    }
  }

  // ─── Quantity & Remove ───────────────────────────────────────
  function bindEvents() {
    drawer.querySelectorAll('.cd__qty-plus').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const numEl = drawer.querySelector(`.cd__qty-num[data-key="${key}"]`);
        cartChange(key, parseInt(numEl.textContent) + 1);
      });
    });

    drawer.querySelectorAll('.cd__qty-minus').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const numEl = drawer.querySelector(`.cd__qty-num[data-key="${key}"]`);
        const current = parseInt(numEl.textContent);
        if (current > 1) cartChange(key, current - 1);
      });
    });

    drawer.querySelectorAll('.cd__remove').forEach((btn) => {
      btn.addEventListener('click', () => cartChange(btn.dataset.key, 0));
    });

    // Close overlay
    drawer.querySelector('#cd-overlay')?.addEventListener('click', closeDrawer);
    drawer.querySelector('#cd-close')?.addEventListener('click', closeDrawer);

    // Note autosave
    const noteEl = drawer.querySelector('#cd-note');
    if (noteEl) {
      let noteTimer;
      noteEl.addEventListener('input', () => {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(() => {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteEl.value }),
          });
        }, 600);
      });
    }
  }

  // ─── Promo Code ─────────────────────────────────────────────
  const promoInput = document.getElementById('cd-promo-input');
  const promoApply = document.getElementById('cd-promo-apply');
  const promoTags = document.getElementById('cd-promo-tags');
  const appliedCodes = new Set();

  function addPromoTag(code) {
    if (!code || appliedCodes.has(code)) return;
    appliedCodes.add(code);
    const tag = document.createElement('span');
    tag.className = 'cd__promo-tag';
    tag.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="7" cy="7" r="1.5" fill="currentColor"/>
      </svg>
      ${code}
      <button class="cd__promo-tag-remove" aria-label="Remove">&times;</button>
    `;
    tag.querySelector('.cd__promo-tag-remove').addEventListener('click', () => {
      appliedCodes.delete(code);
      tag.remove();
    });
    promoTags?.appendChild(tag);
  }

  promoApply?.addEventListener('click', () => {
    const code = promoInput.value.trim().toUpperCase();
    if (code) {
      addPromoTag(code);
      promoInput.value = '';
    }
  });

  promoInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') promoApply.click();
  });

  // ─── Intercept Add-to-Cart forms ────────────────────────────
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const variantId = form.querySelector('[name="id"]')?.value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
    if (variantId) await cartAdd(variantId, qty);
  });

  // ─── Cart icon click (adjust selector to your theme) ────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('a[href="/cart"], .custom-header__icon-btn');
    if (btn) {
      e.preventDefault();
      openDrawer();
    }
  });
  bindEvents();

  // expose globally if needed
  window.cartDrawer = { open: openDrawer, close: closeDrawer, add: cartAdd };
})();